import React, { useState } from 'react';

import JobTabCalender from '@app/Schedule/JobCalender/jobTabCalender';

const WorkDriver = () => {
    //  ask fore type

    const [viewName, setViewName] = useState<string>('Monthly Driver View');

    return (
        <div className="px-4 mt-5">
            <JobTabCalender
                type={'driver'}
                setViewName={setViewName}
                viewName={viewName}
            />
        </div>
    );
};

export default WorkDriver;
